import { TextInput } from '@wrisk/ui-components'
import React, { FunctionComponent, HTMLAttributes, useCallback } from 'react'

import { FormInputProps } from '../types'

export interface TextInputMeta {
  mask?: string
  inputMode: HTMLAttributes<unknown>['inputMode']
}

export const TextFormInput: FunctionComponent<FormInputProps<string, TextInputMeta>> = ({
  name,
  value,
  onChange,
  tKey,
  t,
  tName,
  meta,
}) => {
  const mask = meta?.mask ? RegExp(`^$|${meta.mask}`) : undefined
  const inputMode = meta?.inputMode

  const onInputChange = useCallback(
    (e) => {
      if (mask?.test(e.target.value) ?? true) {
        onChange(e.target.value)
      }
    },
    [mask, onChange],
  )

  return (
    <TextInput
      width={1}
      name={name}
      value={value ?? ''}
      onChange={onInputChange}
      inputMode={inputMode}
      placeholder={t<string>(tKey(tName, 'placeholder'))}
    />
  )
}
